/**
 * input 터치시, 커서를 문자열의 맨 끝으로 이동시키는 디렉티브 (앱 전용)
 * @example
 * <input v-cursor-end />
 *
 * @example
 * <input v-cursor-end="'once'" />
 */
export default {
  mounted(el, binding) {
    let hasFocusedOnce = false;

    const moveCursorEnd = () => {
      if (binding.value === 'once' && hasFocusedOnce) return;

      hasFocusedOnce = true;

      const length = el.value.length ?? 0;

      requestAnimationFrame(() => {
        setTimeout(() => {
          el.setSelectionRange(length, length);
        }, 10);
      });
    };

    el.__moveCursorEnd = moveCursorEnd;
    el.addEventListener('focus', moveCursorEnd);
  },
  unmounted(el) {
    el.removeEventListener('focus', el.__moveCursorEnd);
    delete el.__moveCursorEnd;
  },
};
